import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const ObjetivosEspecificos = () => {
    const { promptData, setPromptData } = useActividadesContext();
    const { proyecto, setProyecto } = useProyecto();

    const handleCharacterizationProyectChange = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto, objetivos_especificos: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            objetivos_especificos: value 
          }));
      };

    
    return (
        <Grid xs={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} > Objetivos específicos</Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Detalla objetivos pedagógicos adicionales o habilidades específicas que deseas fomentar en tus estudiantes</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Ejemplo: Fortalecer el aprendizaje colaborativo y desarrollar habilidades de comunicación efectiva entre los estudiantes'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.objetivos_especificos}
                onChange={handleCharacterizationProyectChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                      color: '#336B87',
                        '&::placeholder': {
                          color: '#336B87',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default ObjetivosEspecificos;




